export const STARLINK_SITES = [
  // Othón P. Blanco
  {
    id: "othon-starlink-1",
    nombre: "Starlink en Othón P. Blanco",
    municipio: "Othón P. Blanco",
    lat: 18.5100,
    lng: -88.3000,
    tipo: "Oficina",
  },

  // Bacalar
  {
    id: "bacalar-starlink-1",
    nombre: "Starlink en Bacalar",
    municipio: "Bacalar",
    lat: 18.6761,
    lng: -88.3923,
    tipo: "Oficina",
  },

  // Tulum
  {
    id: "tulum-starlink-1",
    nombre: "Starlink en Tulum",
    municipio: "Tulum",
    lat: 20.2115,
    lng: -87.4651,
    tipo: "Módulo",
  },

  // Playa del Carmen (Solidaridad)
  {
    id: "solidaridad-starlink-1",
    nombre: "Starlink en Solidaridad",
    municipio: "Solidaridad",
    lat: 20.6270,
    lng: -87.0790,
    tipo: "Oficina",
  },

  // Benito Juárez (Cancún)
  {
    id: "cancun-starlink-1",
    nombre: "Starlink en Benito Juárez",
    municipio: "Benito Juárez",
    lat: 21.1619,
    lng: -86.8515,
    tipo: "Oficina",
  },
];
